<template>
  <div>
    <b-row class="details p-10 pt-20">
      <b-col cols="1"></b-col>
      <b-col cols="10" v-if="edroDetails && edroDetails.length > 0">
        <div class="pt-15 card inner-card br-2" v-for="(edro, index) in edroDetails.filter(edroDetail => edroDetail.identifier === selectedEdro.id)" :key="index">
          <div class="pl-10 pb-15">
            <b-row>
              <b-col cols="3" class="p-0">
                {{ edro.title }}
              </b-col>
            </b-row>
          </div>
          <div class="p-10">
            <div class="pb-10" v-if="edro.category">
              <div class="header">
                Category
              </div>
              <div class="content">
                {{ edro.category }}
              </div>
            </div>
            <div class="pb-10" v-if="edro.description">
              <div class="header">
                Instruction Details
              </div>
              <div class="content">
                {{ edro.description }}
              </div>
            </div>
            <div class="pb-10" v-if="edro.configurationSettings">
              <div class="header">
                Default configuration settings
              </div>
              <div class="content" v-for="(setting, index) in edro.configurationSettings" :key="index">{{ setting.name }}: {{ setting.details }}</div>
            </div>
            <div class="pb-10" v-if="edro.dataCollected">
              <div class="header">
                Data collected
              </div>
              <div class="content">
                <ul>
                  <li v-for="(data, index) in edro.dataCollected" :key="index">{{ data }}</li>
                </ul>
              </div>
            </div>
            <b-row class="pb-10" v-if="edro.scheduler && edro.scheduler.milestones">
              <b-col class="p-0">
                <div class="header">
                  To be completed at milestones
                </div>
                <div class="content">
                  <span v-for="(milestone, index) in edro.scheduler.milestones" :key="index">
                    {{ displayScreeningMilestones(milestone) }}
                    <span v-if="index + 1 < edro.scheduler.milestones.length">,</span>
                  </span>
                </div>
              </b-col>
              <b-col v-if="edro.scheduler.completionWindows" class="p-0">
                <div class="header">
                  Completion windows
                </div>
                <div class="content">{{ Object.values(edro.scheduler.completionWindows).join(", ") }}</div>
              </b-col>
            </b-row>
            <b-row class="pb-10" v-if="edro.scheduler && edro.scheduler.frequency">
              <b-col class="p-0">
                <div class="header">
                  Frequency
                </div>
                <div class="content">
                  {{ edro.scheduler.frequency.title }}
                </div>
              </b-col>
              <b-col v-if="edro.scheduler.completionWindow" class="p-0">
                <div class="header">
                  Completion window
                </div>
                <div class="content">{{ edro.scheduler.completionWindow > 1 ? edro.scheduler.completionWindow + " days" : edro.scheduler.completionWindow + " day" }} </div>
              </b-col>
            </b-row>
            <b-row class="pb-10" v-if="edro.scheduler && edro.scheduler.isActivityOptional">
              <b-col class="p-0">
                <div class="header">
                  Activity is optional and will be excluded from the compliance report.
                </div>
                <div class="content">
                  Yes
                </div>
              </b-col>
            </b-row>
            <b-row class="pb-10" v-if="edro.scheduler && edro.scheduler.allowMultipleTimes">
              <b-col class="p-0">
                <div class="header">
                  Allow participants to repeat activity each time it is present
                </div>
                <div class="content">
                  Yes
                </div>
              </b-col>
            </b-row>
            <b-row class="pb-10" v-if="edro.scheduler && edro.scheduler.duration">
              <b-col class="p-0" cols="4" v-for="(item, index) in edro.scheduler.duration" :key="index">
                <b-col cols="12" class="header p-0" v-if="index === 0 && (item.startDay || item.endDay)">
                  Scheduled as follows
                </b-col>
                <b-row class="p-0">
                  <b-col class="p-0" cols="3" v-if="item.startDay !== null && item.startDay !== undefined">
                    <div class="content">
                      Start Day
                    </div>
                    <div class="content">
                      {{ getDay(studyData.screeningMilestoneAllowed, studyData.screeningDuration, item.startDay) }}
                    </div>
                  </b-col>
                  <b-col class="p-0" cols="3" v-if="item.endDay !== null && item.endDay !== undefined">
                    <div class="content">
                      End Day
                    </div>
                    <div class="content">
                      {{ getDay(studyData.screeningMilestoneAllowed, studyData.screeningDuration, item.endDay) }}
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="pb-10" v-if="edro.scheduler && !(edro.scheduler.milestones && edro.scheduler.milestones.length > 0)">
              <b-col class="p-0" v-if="edro.scheduler.allowUntillDuration">
                <div class="header">
                  Available until the end of participant's study duration
                </div>
                <div class="content">
                  Yes
                </div>
              </b-col>
            </b-row>
            <b-row class="pb-10" v-if="edro.scheduler && edro.scheduler.reminders && edro.scheduler.reminders.length">
              <b-col cols="12" class="header p-0">
                Reminders
              </b-col>
              <b-col class="p-0" cols="12">
                <b-row class="p-0">
                  <b-col class="p-0" cols="2">
                    <div class="header">
                      Day
                    </div>
                  </b-col>
                  <b-col class="p-0" cols="6">
                    <div class="header">
                      Message
                    </div>
                  </b-col>
                  <b-col class="p-0" cols="2">
                    <div class="header">
                      Time
                    </div>
                  </b-col>
                  <b-col class="p-0" cols="2">
                    <div class="header">
                      Notification type
                    </div>
                  </b-col>
                </b-row>
                <b-row class="p-0" v-for="(item, index) in edro.scheduler.reminders" :key="index">
                  <b-col class="p-0" cols="2">
                    <div class="content">
                      {{ item.day }}
                    </div>
                  </b-col>
                  <b-col class="p-0" cols="6">
                    <div class="content" v-if="item.message">
                      {{ item.message }}
                    </div>
                  </b-col>
                  <b-col class="p-0" cols="2">
                    <div class="content" v-if="item.time">
                      {{ item.time }}
                    </div>
                  </b-col>
                  <b-col class="p-0" cols="2">
                    <div class="content">
                      <span>Mobile</span>
                      <span v-if="item.emailToggle">, Email</span>
                      <span v-if="item.smsToggle">, SMS Text</span>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* 
IMPORTANT
Any changes made in this file should also be made in the edros.vue which is inside the study-details-pdf folder
 */
import studyDetailMixin from "@/components/study-details/study-detail-mixin";
export default {
  name: "edro-details",
  data() {
    return {
      studyData: {},
      edroDetails: [],
      selectedEdro: {},
      studyId: this.$route.params.studyId,
      edroId: this.$route.params.edroId
    };
  },
  mixins: [studyDetailMixin],
  methods: {
    async getEdroDetails() {
      try {
        const selectedActivities = await this.$api.getSelectedActivitesFact(this.studyId);
        this.edroDetails = selectedActivities.body;
      } catch (error) {
        this.$toastr.error(error.message || "Unable to fetch the instructions and notifications.");
      }
    },
    getStudyDetails() {
      this.$api.getStudyDataFact(this.studyId).then(
        response => {
          this.studyData = response.body;
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting the study details");
        }
      );
    },
    displayScreeningMilestones(milestone) {
      if ((milestone !== '' || milestone !== null) && this.studyData.screeningMilestoneAllowed && this.studyData.screeningDuration) {
        milestone -= this.studyData.screeningDuration;
      }
      return milestone;
    }
  },
  mounted() {
    this.getEdroDetails();
    this.getStudyDetails();
    this.selectedEdro.id = this.edroId;
  }
};
</script>

<style scoped>
.details {
  background-color: #fff;
  width: 100%;
  height: 100%;
  position: absolute;
}
.inner-card {
  border: none;
  margin: 5px 20px;
  border-radius: 3px !important;
  background-color: #d3dfe4;
}
.content {
  font-size: 12px;
  color: #666669;
}
.header {
  font-size: 12px;
  font-weight: bold;
  color: #666669;
}

.card {
  padding: 15px;
  margin-bottom: 16px;
}
</style>
